import React, { memo } from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
const without = ['Estudiás sin saber qué priorizar', 'Te trabás con las dosis en el examen', 'Llegás a la clínica con miedo', 'Confundís fármacos peligrosos en gatos', 'No sabés armar una historia clínica', 'Te paralizás en una emergencia', 'Improvisás al hablar con el dueño'];
const withProduct = ['Sabés exactamente qué memorizar', 'Calculás dosis con seguridad', 'Entrás con criterio y confianza', 'Conocés cada contraindicación crítica', 'Tenés plantillas listas para usar', 'Aplicás protocolos paso a paso', 'Comunicás como profesional desde el día 1'];
export function Comparison() {
  return <section className="w-full py-12 px-4 bg-white" data-id="element-42">
      <div className="max-w-4xl mx-auto" data-id="element-43">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-center text-slate-900" data-id="element-44">
          La diferencia es enorme
        </h2>

        <div className="grid grid-cols-2 gap-3 sm:gap-5 mt-6" data-id="element-45">
          {/* SIN */}
          <div className="rounded-xl border-2 border-red-200 bg-red-50/50 overflow-hidden" data-id="element-46">
            <div className="bg-red-600 text-white px-3 sm:px-5 py-2.5" data-id="element-47">
              <h3 className="font-extrabold text-sm sm:text-lg flex items-center gap-1.5" data-id="element-48">
                <XIcon className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-49" />{' '}
                <span data-id="element-50">SIN el pack</span>
              </h3>
            </div>
            <ul className="p-3 sm:p-4 space-y-2" data-id="element-51">
              {without.map((t, i) => <li key={i} className="flex items-start gap-2" data-id="element-52">
                  <span className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5 rounded-full bg-red-100 border border-red-300 flex items-center justify-center mt-0.5" data-id="element-53">
                    <XIcon className="w-2.5 h-2.5 sm:w-3 sm:h-3 text-red-700" data-id="element-54" />
                  </span>
                  <span className="text-red-800 font-medium text-xs sm:text-sm leading-snug" data-id="element-55">
                    {t}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* CON */}
          <div className="rounded-xl border-2 border-green-300 bg-green-50/50 overflow-hidden shadow-md shadow-green-100" data-id="element-56">
            <div className="bg-green-600 text-white px-3 sm:px-5 py-2.5" data-id="element-57">
              <h3 className="font-extrabold text-sm sm:text-lg flex items-center gap-1.5" data-id="element-58">
                <CheckIcon className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-59" />{' '}
                <span data-id="element-60">CON el pack</span>
              </h3>
            </div>
            <ul className="p-3 sm:p-4 space-y-2" data-id="element-61">
              {withProduct.map((t, i) => <li key={i} className="flex items-start gap-2" data-id="element-62">
                  <span className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5 rounded-full bg-green-100 border border-green-300 flex items-center justify-center mt-0.5" data-id="element-63">
                    <CheckIcon className="w-2.5 h-2.5 sm:w-3 sm:h-3 text-green-700" data-id="element-64" />
                  </span>
                  <span className="text-green-900 font-medium text-xs sm:text-sm leading-snug" data-id="element-65">
                    {t}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}